import './universalLinkHeaderFooter.css';

import type { User } from 'oidc-client';
import type { ReactNode } from 'react';
import React from 'react';
import {
  ConnectFooter,
  UnauthenticatedConnectHeader
} from '../../headerFooter';
import { AuthenticatedHeader } from './authenticatedHeader';

type UniversalLinkHeaderFooterProps = {
  user?: User | null;
  children: ReactNode;
};

export function UniversalLinkHeaderFooter({
  user,
  children
}: UniversalLinkHeaderFooterProps): JSX.Element {
  const header = user ? (
    <AuthenticatedHeader user={user} />
  ) : (
    <UnauthenticatedConnectHeader />
  );

  return (
    <>
      {header}
      {children}
      <ConnectFooter />
    </>
  );
}
